// src/pages/Sanitary/SanitaryDetailsModal.js

import React from "react";
import { Modal, Button, Table } from "react-bootstrap";

// A reusable component to render each detail row neatly
const DetailRow = ({ label, value }) => (
  <tr>
    <th style={{ width: "30%", background: "#f8f9fa" }}>{label}</th>
    <td>{value || "N/A"}</td>
  </tr>
);

function SanitaryDetailsModal({ show, handleClose, reportData }) {
  if (!reportData) {
    return null;
  }

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Sanitary Report Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table bordered striped responsive="sm">
          <tbody>
            <DetailRow label="Service Type" value={reportData.service_type} />
            <DetailRow
              label="Applicant Name"
              value={reportData.applicant_name}
            />
            <DetailRow
              label="Application Date"
              value={reportData.application_date}
            />
            <DetailRow label="Ward No." value={reportData.ward_no} />
            <DetailRow label="Contact No." value={reportData.contact_no} />
            <DetailRow
              label="Service Details"
              value={reportData.service_details}
            />
            <DetailRow
              label="Status"
              value={
                <span className="text-capitalize">{reportData.status}</span>
              }
            />
            <DetailRow label="Remarks" value={reportData.remarks} />
            <DetailRow
              label="Attachment"
              value={
                reportData.attachment ? (
                  <a
                    href={`${process.env.REACT_APP_API_URL}/${reportData.attachment}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View Attachment
                  </a>
                ) : (
                  "No file attached"
                )
              }
            />
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default SanitaryDetailsModal;
